export default "__VITE_ASSET__QM4IlxWy__"